import React, { ReactElement } from "react";

import { AlertType } from "../enums/alertType";
import Icon from "features/shared/components/icons/Icon";

interface IProps { 
  type: AlertType;
}
  
const AlertIcon : React.FC<IProps> = (props) => {
  switch (props.type) {
    case AlertType.Info:
      return <Icon icon="info-circle" size="2x" />;  
    case AlertType.Success:
      return <Icon icon="check-circle" size="2x" />;  
    case AlertType.Danger:
      return <Icon icon="exclamation-circle" size="2x" />;  
    case AlertType.Warning:
      return <Icon icon="exclamation-circle" size="2x" />;  
    default:
      return null;
  }
}; 

export default AlertIcon;